import { BrowserRouter } from "react-router-dom";
import { AuthProvider } from "./utils/AuthContext";
import RoutesSwitcher from "./utils/RoutesSwitcher";
import './App.css';

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <RoutesSwitcher />
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
